import React from "react";
import { UncontrolledAlert } from "reactstrap";

const AlertExample = () => {
    return (
        <UncontrolledAlert className="c-success">
            I am an alert and I can be dismissed!
        </UncontrolledAlert>
    );
};

export default AlertExample;
